import { gql } from "@apollo/client";

export const GET_API_PROVIDER = gql`
  query MyQuery {
    msgbox_APIProvider(where: { Name: { _nlike: "gupshup" } }) {
      APIProviderId
    }
  }
`;

export const GET_USER_ORGADMIN_ROLE = gql`
  query MyQuery {
    msgbox_Role(where: { Name: { _eq: "OrgAdmin" } }) {
      RoleId
    }
  }
`;

export const GET_EMAILS = gql`
  query GetEmails {
    msgbox_User(where: { IsDeleted: { _eq: false } }) {
      UserId
      EMail
    }
  }
`;

export const GET_PHONE_NUMBERS = gql`
  query GetPhoneNumbers {
    msgbox_APIAccount {
      APIAccountId
      PhoneNumber
    }
  }
`;
